var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmdLogoShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8127 22.7399H11.8031V22.7447H11.6482C5.21677 22.7447 0 17.6538 0 11.3724C0 5.09579 5.21677 0 11.6482 0H11.6579H11.6627H11.8127V4.457H11.8031H11.6627C7.74773 4.46184 4.58282 7.54932 4.58282 11.368C4.58282 15.1911 7.75257 18.2781 11.6676 18.2781H11.8127V22.7399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5307 12.9941C13.3758 13.0623 13.2693 13.1054 13.0467 13.1054C11.8611 13.1054 11.7692 11.958 11.7692 11.958V10.0126L11.7982 9.79L11.8272 9.78516H14.2711V11.7015C14.2711 11.7015 14.1985 12.7086 13.5307 12.9941Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7879 12.9941C19.633 13.0623 19.5266 13.1054 19.2991 13.1054C18.1183 13.1054 18.0264 11.958 18.0264 11.958V10.0126L18.0554 9.79L18.0844 9.78516H20.5283V11.7015C20.5283 11.7015 20.4557 12.7086 19.7879 12.9941Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4924 16.9034C16.3762 16.9373 16.3133 16.9561 16.1681 16.9561C14.9873 16.9561 14.8954 15.8189 14.8954 15.8189V13.8691L14.9196 14.0816L15.026 14.0719H17.3973V15.9921C17.3973 15.9931 17.3102 16.6905 16.4924 16.9034Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6521 12.9941C16.4972 13.0623 16.3859 13.1054 16.1681 13.1054C14.9873 13.1054 14.8954 11.958 14.8954 11.958V10.0126L14.9196 9.79L15.026 9.78516H17.3973V11.7015C17.3973 11.7015 17.3199 12.7134 16.6521 12.9941Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4924 9.1949C16.3762 9.22394 16.3133 9.24329 16.1681 9.24329C14.9873 9.24329 14.8954 8.10606 14.8954 8.10606V6.16065L14.9196 6.12194L15.026 6.10742H17.3973V8.03347C17.3973 8.03347 17.3102 8.97665 16.4924 9.1949Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdLogoShort);
export default __webpack_public_path__ + "static/media/cmd-logo-short.481cc07fe3f2f89b238cd9189f2313f6.svg";
export { ForwardRef as ReactComponent };